module.exports = new __parcel__URL__("plane_2_red.6361f4a2.png").toString();